import { EquipeSelectModel, UnidadeSaudeSelectModel } from 'components/form'
import { LoadImoveisInativacaoQuery } from 'graphql/types.generated'

export const MAXIMUM_INATIVACAO_IMOVEIS_SIZE = 30

export const IMOVEIS_DUPLICADOS_TOOLTIP_TEXT =
  'O sistema considera como possíveis duplicatas os cadastros de imóveis atribuídos à sua equipe e unidade que tem as mesmas informações de endereço, inclusive número e complemento.'

export interface InativacaoImoveisBuscaFormModel {
  logradouro?: string
  cep?: string
  unidadeSaude?: UnidadeSaudeSelectModel
  equipe?: EquipeSelectModel
  microarea?: string
  ocultarImoveisComFamilia?: boolean
}

export type InativacaoImoveisQueryResult = LoadImoveisInativacaoQuery['imoveis']
export type InativacaoImovelItemModel = LoadImoveisInativacaoQuery['imoveis']['content'][0]
export interface InativacaoImovelActionModel {
  id: InativacaoImovelItemModel['id']
  familias: InativacaoImovelItemModel['familias']
  permissaoReterritorializar?: InativacaoImovelItemModel['permissaoReterritorializar']
}

export interface CheckAllActionParams {
  disabled?: boolean
  checkAllChecked: boolean
  checkedItemsSize: number
  validImoveisUncheckedSize: number
}

export interface ItemActionParams {
  disabled?: boolean
  checkedItems: Set<string>
  item: InativacaoImovelItemModel
}
